module.exports = __webpack_public_path__ + "img/fi-toasts-600x395.2ab2e8e0.jpg";